import FinancialInfo from "./FinancialInfo";

export default FinancialInfo;
